// The typed-task card owns standalone pending, ready, and failure states.
// Only a hosted status starts the older recommendation-polling lifecycle.
export const shouldPollHostedDailyInsight = ({ externalDailyTaskId, externalDailyFailureCode, externalDailyCapturePending } = {}) =>
  !externalDailyTaskId && !externalDailyFailureCode && !externalDailyCapturePending;
